import { Line } from "@ant-design/charts";
import { Descriptions, Modal } from "antd";

import { useGraphTheme } from "../../../hooks/useGraphTheme";

const SalesStatsModal = ({ isModalOpen = false, setIsModalOpen = () => {}, salesStats = {} }) => {
  const graphTheme = useGraphTheme();
  const {
    totalPayments,
    discountedPaymentCount,
    totalPaymentVolume,
    totalDiscountGiven,
    paymentCountStats
  } = salesStats;

  const PaymentStatsConfig = {
    data: paymentCountStats || [],
    height: 400,
    xField: "date",
    yField: "count",
    point: {
      size: 5,
      shape: "diamond"
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      title="Course Sale Stats"
      open={isModalOpen}
      footer={[]}
      width={2000}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <br />
      <Descriptions title="Payment Details" column={{ xs: 1, sm: 2, md: 3 }} bordered>
        <Descriptions.Item label="Total Count">{totalPayments}</Descriptions.Item>
        <Descriptions.Item label="Discount Count">{discountedPaymentCount}</Descriptions.Item>
        <Descriptions.Item label="Total Volume">{totalPaymentVolume}</Descriptions.Item>
        <Descriptions.Item label="Total Discount">{totalDiscountGiven}</Descriptions.Item>
      </Descriptions>
      <Line {...PaymentStatsConfig} {...graphTheme} />
    </Modal>
  );
};
export default SalesStatsModal;
